import { Pressable, Text, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { cn } from '@/utils/cn'
import { useRouter } from '@/utils/navigation'

import { ArrowBack } from '../icon'
import ScreenHeader from '../ScreenHeader'

export default function OrderHeader({ text = '', onPress }: { text?: string; onPress?: () => void }) {
  const router = useRouter()
  const { top } = useSafeAreaInsets()

  return (
    <View className={'bg-background-primary'} style={{ paddingTop: top }}>
      <ScreenHeader
        leftElement={
          <Pressable className={'p-2'} onPress={() => router.back()}>
            {({ pressed }) => <ArrowBack className={cn('size-6 text-text-tertiary', pressed && 'opacity-50')} />}
          </Pressable>
        }
        rightElement={
          <Pressable className={'p-2'} onPress={onPress}>
            {({ pressed }) => (
              <Text className={cn('text-base font-medium text-text-tertiary', pressed && 'opacity-50')}>{text}</Text>
            )}
          </Pressable>
        }
      />
    </View>
  )
}
